var map = {
	"./Coinsdataflow.jpeg": 306,
	"./Cointelegraph.jpeg": 307,
	"./Concerto-Logo.png": 308,
	"./EY.jpeg": 309,
	"./FinancialIT.jpeg": 310,
	"./IDS Fintech Logo/fintech logo/250-100px/fintech-logo---blue-type.png": 311,
	"./IDS Fintech Logo/fintech logo/250-100px/fintech-logo---white-type.png": 312,
	"./IDS Fintech Logo/fintech logo/800 verticl version/fintech-logo-blue-version.png": 313,
	"./IDS Fintech Logo/fintech logo/800 verticl version/fintech-logo-white-version.png": 314,
	"./IDS Fintech Logo/fintech logo/high Res horizontal/landscape-white-text.png": 315,
	"./ManageEngine.png": 316,
	"./NIIT.jpeg": 317,
	"./Neosoft.jpeg": 318,
	"./NewsAffinity.jpeg": 319,
	"./Payoneer.jpeg": 320,
	"./TEMENOS.png": 321,
	"./Vaccumlabs.jpg": 322,
	"./Watermelon.jpeg": 323,
	"./abaka.jpg": 324,
	"./africa.jpeg": 325,
	"./ambidextr.jpeg": 326,
	"./appway.png": 327,
	"./arabnet.jpeg": 328,
	"./aroundb.png": 329,
	"./avaya.png": 330,
	"./azentio.jpg": 331,
	"./backbase.jpeg": 332,
	"./backbase.png": 333,
	"./bankingcio.jpeg": 334,
	"./bankserv.jpg": 335,
	"./bc.jpeg": 336,
	"./beingcrypto.png": 337,
	"./bigdata.jpeg": 338,
	"./blocksocial.jpeg": 339,
	"./caia.jpeg": 340,
	"./cibe.jpeg": 341,
	"./coforge.jpg": 342,
	"./coinpedia.jpeg": 343,
	"./coinquora.png": 344,
	"./coinrepublic.png": 345,
	"./coinsflare.jpeg": 346,
	"./comarch.jpeg": 347,
	"./comforte_logo.png": 348,
	"./comviva.png": 349,
	"./confluent.jpg": 350,
	"./conrad.png": 351,
	"./consdata.jpeg": 352,
	"./creatio.png": 353,
	"./cryptoSaudi.png": 354,
	"./cryptonewz.jpeg": 355,
	"./daon.jpg": 356,
	"./darktrace.png": 357,
	"./difc.jpg": 358,
	"./difc.png": 359,
	"./edb.png": 360,
	"./expo.jpeg": 361,
	"./expo2020.png": 362,
	"./faloos.jpg": 363,
	"./findbiometrics.jpeg": 364,
	"./fintech.jpeg": 365,
	"./fintechfinance.jpeg": 366,
	"./fintechfutures.jpeg": 367,
	"./fintechgalaxy.jpeg": 368,
	"./fintechgalaxy.jpg": 369,
	"./fintechpower.jpeg": 370,
	"./fintechtimes.jpeg": 371,
	"./fireeye.png": 372,
	"./freshworks.png": 373,
	"./fss.png": 374,
	"./hcl.jpg": 375,
	"./hyperpay.jpeg": 376,
	"./ibm.jpeg": 377,
	"./ids.png": 378,
	"./ie.jpg": 379,
	"./igologic.jpg": 380,
	"./iib.jpeg": 381,
	"./infobip.jpeg": 382,
	"./infosys.jpg": 383,
	"./infrasoft.png": 384,
	"./investera.jpeg": 385,
	"./kissflow.jpg": 386,
	"./kitamo.jpeg": 387,
	"./maxut.png": 388,
	"./menafintech.jpeg": 389,
	"./microsoft.png": 390,
	"./mobileidworld.jpeg": 391,
	"./neosoft.png": 392,
	"./network.jpg": 393,
	"./newgen.png": 394,
	"./onespan.jpeg": 395,
	"./onespan.jpg": 396,
	"./openfactor.png": 397,
	"./oracle.jpeg": 398,
	"./oxford.png": 399,
	"./paypers.jpg": 400,
	"./piotech.png": 401,
	"./privatebanking.jpeg": 402,
	"./pwc.jpeg": 403,
	"./pwc.jpg": 404,
	"./rakbank.png": 405,
	"./recorded.png": 406,
	"./regtech.png": 407,
	"./scventure.jpg": 408,
	"./sinofy.png": 409,
	"./skiply.png": 410,
	"./smart.png": 411,
	"./smartmessage.png": 412,
	"./smartstream.jpeg": 413,
	"./smartstream.png": 414,
	"./tata.jpeg": 415,
	"./tcs.jpg": 416,
	"./telco.jpeg": 417,
	"./temenos.jpg": 418,
	"./threatLocker.jpg": 419,
	"./tripwire.jpeg": 420,
	"./truebanking.jpeg": 421,
	"./turbonomic.png": 422,
	"./ufg.png": 423,
	"./unlock.png": 424,
	"./yethi.png": 425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;